import { Component, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/base/base.component';
import { Config } from 'src/infrastructure/config';
import { MobileContacts } from 'src/models/DTO/contact/mobileContacts';
import { LocalstorageService } from 'src/services/core/localstorage/localstorage.service';

@Component({
  selector: 'app-invitecontacts',
  templateUrl: './invitecontacts.component.html',
  styleUrls: ['./invitecontacts.component.css']
})
export class InvitecontactsComponent extends BaseComponent implements OnInit {

  private _mobileContacts: MobileContacts = { data: [] };

  constructor(
    private localStorage: LocalstorageService
  ) {
    super();
  }


  ngOnInit(): void {
    this._mobileContacts.data = JSON.parse(this.localStorage.getLocalStorageItem(Config.contactsLSKey) || '[]');
    this._mobileContacts.data.forEach(contact => {
      contact.selected = false;
    })
  }

  get contacts() {
    return this._mobileContacts;
  }

  get notSelectedContacts() {
    return this._mobileContacts.data.filter(contact => !contact.selected)
  }

  get selectedContacts() {
    return this._mobileContacts.data.filter(contact => contact.selected)
  }

  toggle(event: any, mobileContact: any) {
    mobileContact.selected = event.target.checked;
  }

  invitePerson(){
    console.log(this.selectedContacts)
  }

  getStyle(index: number, elements: any[]) {
    if (index == 0) {
      return 'width: 100%; margin: auto;  background-color: white; padding: 10px; border-top-left-radius: 10px; border-top-right-radius: 10px'

    }
    else if (index == elements.length - 1) {
      return 'width: 100%; margin: auto;  background-color: white; padding: 10px; border-bottom-left-radius: 10px; border-bottom-right-radius: 10px'
    }
    return 'width: 100%; margin: auto;  background-color: white; padding: 10px; border-radius: 0px'
  }
}
